import { render, staticRenderFns } from "./SalesChannelModal__Style#Drawer.vue?vue&type=template&id=56c1390c&scoped=true&"
import script from "./SalesChannelModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./SalesChannelModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./SalesChannelModal__Style#Drawer.vue?vue&type=style&index=0&id=56c1390c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c1390c",
  null
  
)

export default component.exports